import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { OfficesSection } from "@/components/site/OfficesSection";
import { OfficeMap } from "@/components/site/OfficeMap";
import heroImg from "@/assets/pulso33-hero.jpg";
import { useT } from "@/lib/i18n";

export const Route = createFileRoute("/about/oficinas")({
  component: Locations,
  head: () => ({
    meta: [
      { title: "Where we are — PULSO33" },
      { name: "description", content: "PULSO33 is a remote-first engineering team operating across Europe and the Americas." },
      { property: "og:title", content: "Where PULSO33 works" },
      { property: "og:description", content: "Remote-first, distributed team. Europe & the Americas." },
      { property: "og:url", content: "https://pulso33.com/about/oficinas" },
      { property: "og:image", content: heroImg },
    ],
    links: [{ rel: "canonical", href: "https://pulso33.com/about/oficinas" }],
  }),
});

function Locations() {
  const { tk } = useT();

  return (
    <Layout>
      <section className="relative border-b border-gold/15">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImg})` }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-background/80 backdrop-blur-[2px]" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-6 py-24 md:py-32 text-center">
          <span className="text-xs tracking-[0.4em] uppercase text-gold">
            {tk("locations.kicker", "Where we work")}
          </span>
          <h1 className="font-serif text-5xl md:text-7xl mt-5 max-w-4xl mx-auto">
            {tk("locations.title.a", "Remote-first. ")}
            <em className="not-italic gold-gradient">{tk("locations.title.b", "Worldwide.")}</em>
          </h1>
          <p className="mt-6 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            {tk(
              "locations.intro",
              "A distributed engineering team across Europe and the Americas. Async-first, on your hours when it matters.",
            )}
          </p>
        </div>
      </section>

      <OfficesSection />
      <OfficeMap />
    </Layout>
  );
}
